import React from "react";
import { useSelector } from "react-redux";

import {
  DSelect,
  HCheckbox,
  passParamsThrough,
} from "../../../validation/HForm";

export const LayoutOperationReport = ({
    cashBoxesClient,
    resetError,
    styles,
  ...props
}) => {
  const { branches } = useSelector(({ handbook }) => handbook);

  const branchOptions =
    branches?.map(({ branchId, branchName }) => ({
      label: branchName,
      value: branchId,
    })) || [];

  return passParamsThrough(
    <>
      <div className="form-row">
        <div className="form-row-item">
          <div className="form-element">
            <label className="form-element-label" htmlFor="">
              Филиал
            </label>
            <div className="form-element-data combobox client">
              <DSelect
                h="true"
                name="branchIdFilter"
                className="client-select"
                placeholder="Выберите"
                options={branchOptions}
                isSearchable={true}
                isLoading={false}
                isMulti={true}
                closeMenuOnSelect={false}
                handleOnChange={resetError}
                styles={styles}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="form-row">
        <div className="form-row-item">
          <div className="form-element">
            <label className="form-element-label" htmlFor="">
              Департамент
            </label>
            <div className="form-element-data combobox client">
              <DSelect
                h="true"
                name="cashBoxIdFilter"
                options={cashBoxesClient}
                placeholder="Выберите"
                isMulti={true}
                isSearchable={true}
                closeMenuOnSelect={false}
                styles={styles}
                handleOnChange={resetError}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="form-row">
        <div className="form-row-item">
          <div className="form-element">
            <div className="d-flex align-center h-100">
              <HCheckbox
                h="true"
                name="allBranches"
                label="Все филиалы / департаменты"
                className="input"
                onChange={resetError}
              />
            </div>
          </div>
        </div>
      </div>
    </>,
    props
  );
};
